import * as z from "zod";

/** The Buy with Shop Pay setting and whether the store is ready for it. Not found while the flag is off. */
export const getShopPayCapability = {
  name: "getShopPayCapability" as const,
  input: z.object({
    /** Re-run the readiness check instead of using the cached result. */
    refresh: z.boolean().optional(),
  }),
  output: z.object({
    enabled: z.boolean(),
    guidance: z.string().nullable(),
    isShopifyStore: z.boolean(),
    /** Null until checked: a page view checks only when Shop Pay is on, or on Check again. */
    readiness: z
      .object({
        ready: z.boolean(),
        /** A `ShopPayReadinessIssue`: `not_in_catalog`, `no_available_products`, `store_refused`, `shop_pay_not_offered` or `check_failed`. */
        issue: z.string().nullable(),
        checkedAt: z.string(),
      })
      .nullable(),
  }),
};
